import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import qs from 'qs'

export const collection = 'caseEvents'

export const schema = new schemas.Array(new schemas.Entity(collection))

type RequestParametersType = {
  caseId: string
  offset: number
  pagesize: number
  filter?: { type: string; taskId: string }
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (requestParameters: RequestParametersType) => {
    const { caseId, offset, pagesize, filter } = requestParameters
    const paramsWithoutCaseId = { offset, pagesize, ...filter }
    let url = `${apiBase}/cases/${caseId}/events${qs.stringify(
      paramsWithoutCaseId,
      { addQueryPrefix: true }
    )}`

    return callApi(url, schema)
  }
